import React, { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import styled from 'styled-components'

import { AnimatedWindowCallbackContext } from 'context/window/AnimatedWindowProvider'
import { sendWebViewMsg } from 'utils/bridge'

import AnimatedWindowHeader from './AnimatedWindowHeader'

export default function AnimatedWindow({ id, headerProps, children }) {
  const { closeWindow } = useContext(AnimatedWindowCallbackContext)
  const location = useLocation()

  useEffect(() => {
    window.history.pushState(null, '')
    sendWebViewMsg({
      action: 'RES_URL_HISTORY_CHANGE',
      data: {
        action: 'PUSH',
        location,
      },
    })

    const popEventHandler = () => {
      closeWindow(id)
    }

    window.addEventListener('popstate', popEventHandler)

    return () => {
      window.removeEventListener('popstate', popEventHandler)
    }
  }, [])

  return (
    <AnimatedWindowSection
      animate={{
        left: '0',
      }}
      exit={{
        left: '100%',
      }}
    >
      <AnimatedWindowHeader
        onBack={() => {
          window.history.back()
          closeWindow(id)
        }}
        {...headerProps}
      />
      {children}
    </AnimatedWindowSection>
  )
}

const AnimatedWindowSection = styled(motion.div)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: #fff;
  overflow-y: hidden;
  z-index: 400;
  transition: all 0.3s cubic-bezier(0, 1, 0, 1) 0;
`
